"use client";

import Link from "next/link";
import { SearchX } from "lucide-react";

import { Button } from "@/components/ui/button";

export function NoResults() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <SearchX className="h-12 w-12 text-slate-300" />
      <div>
        <h2 className="text-lg font-semibold text-slate-900">No items matched your filters</h2>
        <p className="mt-1 text-sm text-slate-500">Try clearing filters or widening your search.</p>
      </div>
      <Button asChild variant="outline">
        <Link href="/items">Clear all filters</Link>
      </Button>
    </div>
  );
}
